// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PrintButton-wrapper {
  position: relative;
}
.PrintButton-wrapper .PrintButton-button svg {
  fill: currentColor;
}
.PrintButton-wrapper .PrintButton-button:disabled {
  cursor: not-allowed;
}
.PrintButton-wrapper .PrintButton-button[aria-busy=true] {
  cursor: progress;
}`, "",{"version":3,"sources":["webpack://./src/components/PrintButton/index.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;AACF;AACE;EACE,kBAAA;AACJ;AAEE;EACE,mBAAA;AAAJ;AAEE;EACE,gBAAA;AAAJ","sourcesContent":[".PrintButton-wrapper {\n  position: relative;\n\n  .PrintButton-button svg {\n    fill: currentColor;\n  }\n\n  .PrintButton-button:disabled {\n    cursor: not-allowed;\n  }\n  .PrintButton-button[aria-busy='true'] {\n    cursor: progress;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
